/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ruptllhvxvbyxhfydyngjayjri.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-6lkxtsgxbbb3foqxqu7ed6k2p4",
    "aws_cloud_logic_custom": [
        {
            "name": "bwrDigiEndpoint",
            "endpoint": "https://7krqahgu7l.execute-api.us-east-1.amazonaws.com/fcmiprod",
            "region": "us-east-1"
        },
        {
            "name": "bwrEndpoint",
            "endpoint": "https://0jcnm74vml.execute-api.us-east-1.amazonaws.com/fcmiprod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:6b3a0450-bded-490a-9896-bc882171d2aa",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_x1WVkDJft",
    "aws_user_pools_web_client_id": "3efri5h1mer69hnjetnsl4jbfl",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "bwr-dashboard-fcmiprod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1qk2umyj22701.cloudfront.net"
};


export default awsmobile;
